<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='14'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-row>
            <el-col :span="2" style="float: right;">
              <div style="padding-top:5px;padding-left:45px;" class="thisclose">
                <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
              </div>
            </el-col>
          </el-row>
          <div class="cght_subpagemaina">
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" style="width: 100%" v-loading="isLoading" border>
                  <el-table-column label="任务名称" align="center" width="150">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" placement="top">
                        <p>{{ scope.row.task_name }}</p>
                        <div slot="reference" class="name-wrapper">
                          <span>{{ scope.row.task_name }}</span>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="提出人" align="center" width="80">
                    <template slot-scope="scope">
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.name }}</el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="提交时间" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{ scope.row.subtime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="是否完成" width="110">
                    <template slot-scope="{row}">
                      <el-switch
                        style="display: block"
                        v-model="row.state"
                        active-value="2"
                        inactive-value="1"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeState(row)"
                        active-text="是"
                        inactive-text="否">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="跟进人" align="center" width="180">
                    <template slot-scope="scope">
                      <div slot="reference" class="name-wrapper">
                        <template>
                          <span v-for="(item,index) in scope.row.participant_list" :key="index" size="medium" style="margin-left: 5px;margin-top: 5px;">{{ item.name }}</span>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="300">
                    <template slot-scope="scope">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:600px" v-if="scope.row.ramke" class="set-popper" v-html="scope.row.ramke.replace(/\n/g, '<br>')"></div>
                        </template>
                        <div slot="reference" class="set-content">
                          {{ scope.row.ramke }}
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="注意事项" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{ scope.row.be_careful }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="规格型号" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{ scope.row.specification }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="回执单号" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{ scope.row.receipt_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="购买链接" align="center">
                    <template slot-scope="scope">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:600px" v-if="scope.row.url" class="set-popper" v-html="scope.row.url.replace(/\n/g, '<br>')"></div>
                        </template>
                        <div slot="reference" class="set-content">
                          {{ scope.row.url }}
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template slot-scope="scopes">
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-for="(item,index) in scopes.row.screenshot" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(item.response)">预览\下载</el-button>
                            <!-- <span style="float: right;cursor: pointer;" @click="dowloadFile(item.response)">下载</span> -->
                          </li>
                        </ul>
                        <el-button v-if="scopes.row.screenshot.length > 0" slot="reference" size="mini" type="text">任务文件</el-button>
                      </el-popover>
                      <el-button slot="trigger" size="mini" type="text" @click="handleEdit(scopes.row)">任务进度</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="pctasklist" />
              </el-col>
            </el-row>
            <el-image
              style="width: 0px; height: 0px"
              :src="url"
              :lazy="true"
              ref="preview"
              :preview-src-list="srcList">
            </el-image>
            <el-image
              style="width: 0px; height: 0px"
              src="https://serv.nmzp.com/uploads/1/image/20240411/80a00fa3ad3f307570961bf8e65621e7.jpg"
              :lazy="true"
              ref="newpreview"
              :preview-src-list="newSrcList"
            >
            </el-image>
            <el-dialog
              title="任务进度"
              :visible.sync="dialogVisible"
              width="30%"
            >
              <div v-if="isShow" class="block" style="height: 50px;">
                <span class="demonstration" style="margin-top: 5px;float: left;">完成进度：</span>
                <el-slider v-model="schedule" :format-tooltip="formatTooltip" :marks="marks" style="margin-left: 10px;float: left;width: 80%"></el-slider>
              </div>
              <el-upload
                ref="upload"
                class="upload-demo"
                list-type="text"
                :action="upload_url"
                :on-success="handlesuccess"
                :on-preview="handlePreview"
                :on-remove="removeUpload"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.pdf,.zip,.rar,.png"
                :file-list="myfileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="true"
              >
                <!-- <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" src="../../assets/images/scwj.jpg">
                  <span class="el-upload-list__item-actions">
                    <span  class="el-upload-list__item-delete" @click="removeUpload(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div> -->
                <el-button slot="trigger" size="mini" type="primary" style="margin-top: 20px">上传文件</el-button>
              </el-upload>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="subUploadFiel">确 定</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import apiConfig from '../../../config/api.config.js'
import api from '@/api/task'
import { getToken, getType } from '@/utils/auth'

export default {
  name: 'TaskAllocation',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'id',
        sort: 'DESC'
      },
      dialogVisible: false,
      form: {
        task_name: '',
        participant: '',
        sate: 0,
        task_id: '',
        screenshot: '',
        introducer: '',
        subtime: '',
        priority: '',
        ramke: ''
      },
      srcList: [],
      newSrcList: ['https://serv.nmzp.com/uploads/1/image/20240411/80a00fa3ad3f307570961bf8e65621e7.jpg'],
      url: '',
      isLoading: false,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      myfileList: [],
      rowID: '',
      schedule: 0,
      isShow: false,
      marks: {
        20: '20%',
        40: '40%',
        60: '60%',
        80: '80%'
      }
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.pctasklist()
  },
  methods: {
    handlePreview (file) {
      window.open(file.response.message, '_target')
    },
    handleEdit (row) {
      this.dialogVisible = true
      this.myfileList = row.task_file_list ? row.task_file_list : []
      this.rowID = row.id
      if (row.auditing === '需要审核') {
        this.isShow = true
        this.schedule = row.schedule ? row.schedule : 0
      } else {
        this.isShow = false
      }
    },
    pctasklist () {
      this.isLoading = true
      api.pctasklist(this.listQuery).then(response => {
        this.list = response.items
        this.total = response.total
        this.isLoading = false
      })
    },
    changeState (state) {
      api.changeState(state).then((response) => {
        this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
      })
    },
    removeUpload (file, fileList) {
      this.myfileList = fileList
    },
    handlesuccess (response, file, fileList) {
      if (response.code === 20000) {
        this.myfileList = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'zip'
      const extension8 = testmsg === 'rar'
      const extension9 = testmsg === 'png'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8 && !extension9) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、pdf、zip、rar、png格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || extension8 || extension9) && isLt2M
    },
    handleClick (row) {
      const thisType = getType(row.screenshot)
      if (thisType === 'image') {
        this.srcList = [row.screenshot]
        this.url = row.screenshot
        this.$nextTick(() => {
          this.$refs.preview.clickHandler()
        })
      } else if (thisType === 'pdf') {
        window.open(row.screenshot, '_target')
      } else {
        const url = 'http://view.officeapps.live.com/op/view.aspx?src=' + row.screenshot
        window.open(url, '_target')
      }
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.newpreview.clickHandler()
      })
    },
    subUploadFiel () {
      api.subUploadFiel({task_file_list: this.myfileList, rowID: this.rowID, schedule: this.schedule}).then(res => {
        this.dialogVisible = false
        this.pctasklist()
      })
    },
    formatTooltip (val) {
      return val + '%'
    },
    dowloadFile (urlFile) {
      window.open(urlFile.message, '_blank')
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 55px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
.set-content{
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 文本溢出时显示省略号 */
  white-space: nowrap; /* 文本不换行 */
}
.set-popper{
  max-height: 300px;
  overflow: auto;
}
.set-popper::-webkit-scrollbar {/*滚动条整体样式*/
  width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.set-popper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  border-radius: 10px;
  background: #c1c1c1;
}
.set-popper::-webkit-scrollbar-track {/*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/view/member/taskAllocation.vue